<script setup lang="ts">
import { ref, watch } from 'vue';
import { UiDialog, UiTextarea } from '@shopexperts/shared';

defineProps<{
  isLoading?: boolean;
}>();

const model = defineModel<boolean>({ default: false });

const emit = defineEmits<{
  confirm: [notes?: string];
  cancel: [];
}>();

const moderationNotes = ref('');

watch(model, (isOpen) => {
  if (!isOpen) {
    moderationNotes.value = '';
    emit('cancel');
  }
});

const handleConfirm = () => {
  emit('confirm', moderationNotes.value);
};

const handleCancel = () => {
  model.value = false;
};
</script>

<template>
  <UiDialog
    v-model="model"
    title="Approve Review"
    text="You're about to publish this review. It will be visible to the public once approved."
    primary-action-label="Approve Review"
    secondary-action-label="Cancel"
    @primary-action="handleConfirm"
    @secondary-action="handleCancel"
  >
    <UiTextarea
      v-model="moderationNotes"
      label="Moderation Notes (Optional)"
      placeholder="Enter moderation notes..."
      :rows="4"
      :disabled="isLoading"
    />
  </UiDialog>
</template>
